exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stick-block-ui {\n  border-radius: 5px;\n  padding: 1em;\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.3);\n  color: white;\n  height: 100%; }\n\n.info {\n  background: #5bc0de; }\n\n.alarm {\n  background: #d9534f; }\n\n.success {\n  background: #5cb85c; }\n\n.warn {\n  background: #f0ad4e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/stiks/stick.style.scss
// module id = ../../../../../src/app/components/stiks/stick.style.scss
// module chunks = main